import { ChannelStats } from '../../types/accounts';
import { Sparkline } from './Sparkline';

const FIELD_LABELS: Record<string, [string, string][]> = {
  email: [['emails_sent_count', 'Sent'], ['open_count_unique', 'Opens'], ['reply_count_unique', 'Replies'], ['bounced_count', 'Bounced']],
  linkedin: [['invited', 'Invited'], ['accepted', 'Accepted'], ['replied', 'Replied'], ['msg1', 'Msg 1'], ['msg2', 'Msg 2'], ['msg3', 'Msg 3']],
};

// Only the headline metrics get a sparkline (scope guard: not every metric).
const HEADLINE: Record<string, string[]> = {
  email: ['emails_sent_count', 'open_count_unique', 'reply_count_unique'],
  linkedin: ['invited', 'accepted', 'replied'],
};

interface Props { title: string; channel: 'email' | 'linkedin'; stats?: ChannelStats; }

export function ChannelFunnel({ title, channel, stats }: Props) {
  if (!stats || !stats.latest) {
    return <div className="text-xs text-neutral-400">No {title.toLowerCase()} data</div>;
  }
  const fields = FIELD_LABELS[channel];
  const synced = stats.last_synced ? new Date(stats.last_synced).toLocaleDateString() : null;
  return (
    <div>
      <div className="text-13 font-semibold text-neutral-700 mb-1">
        {title}{synced ? <span className="text-xs text-neutral-400 font-normal"> · synced {synced}</span> : null}
      </div>
      <div className="flex flex-wrap gap-2">
        {fields.map(([key, label]) => {
          const v = stats.latest?.[key] ?? 0;
          const d = stats.delta?.[key] ?? 0;
          return (
            <div key={key} className="min-w-14 bg-neutral-50 border border-neutral-100 rounded-md px-2.5 py-2">
              <div className="text-base font-semibold text-neutral-900 leading-none">
                {v}
                {d !== 0 ? (
                  <span className={`ml-1 text-xs font-normal ${d > 0 ? 'text-success-600' : 'text-error-600'}`}>
                    {d > 0 ? '+' : ''}{d}
                  </span>
                ) : null}
              </div>
              <div className="text-2xs text-neutral-500 mt-0.5">{label}</div>
              {stats.series?.[key] && HEADLINE[channel].includes(key) ? (
                <Sparkline values={stats.series[key]} className="mt-1 w-full" />
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
}
